/**
 * Get user's current location using browser geolocation API
 * @param {function} onSuccess - Callback with { lat, lng, accuracy }
 * @param {function} onError - Callback with error message
 */
export const getCurrentLocation = (onSuccess, onError) => {
  if (!navigator.geolocation) {
    onError('Geolocation is not supported by your browser');
    return;
  }

  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const { latitude, longitude, accuracy } = position.coords;
      onSuccess({ lat: latitude, lng: longitude, accuracy });
    },
    (error) => {
      const errorMessages = {
        1: 'Location permission denied. Please enable location access in settings.',
        2: 'Location could not be determined. Check your internet connection.',
        3: 'Location request timed out. Please try again.',
      };
      onError(errorMessages[error.code] || 'Unknown location error');
    },
    options
  );
};

/**
 * Check if geolocation is supported and permitted
 * @returns {boolean}
 */
export const isGeolocationSupported = () => {
  return !!navigator.geolocation;
};

/**
 * Watch user's location changes
 * @param {function} onLocationChange - Callback with new location
 * @param {function} onError - Callback with error
 * @returns {number} Watch ID (use to clear with clearWatch())
 */
export const watchLocation = (onLocationChange, onError) => {
  if (!navigator.geolocation) {
    onError('Geolocation not supported');
    return null;
  }

  return navigator.geolocation.watchPosition(
    (position) => {
      const { latitude, longitude } = position.coords;
      onLocationChange({ lat: latitude, lng: longitude });
    },
    onError
  );
};
